/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction } from 'deox';
import {
  GET_BALANCE_REQUEST,
  GET_BALANCE_SUCCESS,
  GET_BALANCE_FAILURE,
  CREATE_BALANCE_REQUEST,
  CREATE_BALANCE_SUCCESS,
  CREATE_BALANCE_FAILURE,
  BalanceDTO,
} from './types';

// Экшен для получения баланса
export const getBalanceAction = {
  request: createAction(GET_BALANCE_REQUEST),
  success: createAction(GET_BALANCE_SUCCESS, resolve => (data: BalanceDTO) => resolve(data)),
  failure: createAction(GET_BALANCE_FAILURE, resolve => (error: string) => resolve(error)),
};

// Экшен для создания баланса
export const createBalanceAction = {
  request: createAction(CREATE_BALANCE_REQUEST),
  success: createAction(CREATE_BALANCE_SUCCESS, resolve => (data: BalanceDTO) => resolve(data)),
  failure: createAction(CREATE_BALANCE_FAILURE, resolve => (error: string) => resolve(error)),
};

// // Экшен для создания операции
// export const createOperationAction = {
//   request: createAction(
//     CREATE_OPERATION_REQUEST,
//     resolve => (operationData: any) => resolve(operationData),
//   ),
//   success: createAction(CREATE_OPERATION_SUCCESS, resolve => (data: BalanceDTO) => resolve(data)),
//   failure: createAction(CREATE_OPERATION_FAILURE, resolve => (error: string) => resolve(error)),
// };
